import React, { Component } from 'react';
import { Row, Field, Label, Button, TextInput, TextArea }  from '../../generic'
import styled from 'styled-components';
import { ToolTip } from '../../forms/eventFormComponents';

class Message extends Component {
  
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        <h2 style={{marginBottom: '20px'}}>Invitation Message</h2>
        <Row>
          <Field name="userEvent[host_name]">
            <Label value="Hosting Person or Organization" required={true} />
            <TextInput  autoFocus="true" value={userEvent.host_name} onChange={onChange} />
          </Field>
        </Row>
        <Row>
          <Field name="userEvent[invitation_message]" error={false}>
            <Label value="Your Message" required={true} style={{display: 'inline-block'}} />
            <ToolTip style={{display: 'inline-block'}} linkText='What is this?' className="left">Your message adds a personal touch, such as telling guests why you’re hosting, what to bring, and maybe encouraging them to bring a friend.</ToolTip>
            <TextArea value={userEvent.invitation_message} onChange={onChange} rows={5} />
          </Field>
          
        </Row>
      </React.Fragment>
    )
  }
}

export default Message
